import React, { useMemo, useState, useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { isNull, isEmpty } from 'lodash';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import { IconButton } from '@material-ui/core';
import PropTypes from 'prop-types';

import { Input, Select, DateTime, RadioGroup } from '~/components/Form';
import { ADM } from '~/constants/perfil';

import * as S from './styles';

function Dados({ formRef }) {
  const { gloperfilid } = useSelector((state) => state.user.profile);
  const { find } = useSelector((state) => state.orgao);

  const [note, setNote] = useState(true);
  const [publish, setPublish] = useState(null);
  const [visibility, setVisibility] = useState(
    !!find.orga_data_publicacao_contrato
  );

  const optionsAI = useMemo(
    () => [
      { value: 'A', label: 'Ativo' },
      { value: 'I', label: 'Inativo' },
    ],
    []
  );

  const optionsSN = useMemo(
    () => [
      { label: 'Sim', value: 'S' },
      { label: 'Não', value: 'N' },
    ],
    []
  );

  const optionsTP = useMemo(
    () => [
      { value: 'T', label: 'Tomador' },
      { value: 'P', label: 'Prestador' },
      { value: ' ', label: '' },
    ],
    []
  );

  const handleToggleVisibilityFieldDate = useCallback(() => {
    setVisibility((state) => !state);
  }, []);

  const handleChangeFieldContract = useCallback((value) => {
    formRef.current.setFieldValue('orga_data_publicacao_contrato', value);
  }, []);

  useEffect(() => {
    if (isNull(find.orga_data_publicacao_contrato)) setVisibility(false);
    else setVisibility(true);
  }, [find.orga_data_publicacao_contrato]);

  useEffect(() => {
    if (!isEmpty(find)) {
      if (visibility) handleChangeFieldContract(publish);
      else handleChangeFieldContract(null);
    }
  }, [visibility, find, publish]);

  return (
    <S.Container>
      <Input disabled name="orga_codigo" label="Código" />

      <Input disabled name="orga_nome" label="Nome" />

      <Input disabled name="orga_cgc" label="CNPJ" />

      <Select disabled name="orga_status" label="Status" options={optionsAI} />

      {gloperfilid === ADM && (
        <>
          <fieldset>
            <legend className="__legend">Dados para pré fatura</legend>

            <Input
              disabled
              name="orga_data_ultimo_periodo"
              label="Data Último Período"
            />

            <Input name="orga_endereco_cobranca" label="Endereço Cobrança" />

            <Input name="orga_municipio_cobranca" label="Munípio Cobrança" />

            <RadioGroup
              name="orga_retem_issqn"
              label="Órgão Retém ISSQN"
              options={optionsSN}
            />

            <Select
              name="orga_responsavel_issqn"
              label="Responsável ISSQN"
              options={optionsTP}
            />

            <Input
              name="orga_aliquota_issqn"
              label="Alíquota ISSQN"
              type="number"
            />

            <Input name="orga_numero_contrato" label="Número do Contrato" />

            {!visibility ? (
              <S.ContainerEyer>
                <Input
                  disabled
                  name="orga_data_publicacao_contrato"
                  label="Data Publicação Contrato"
                  value="00/00/0000"
                />

                <IconButton onClick={handleToggleVisibilityFieldDate}>
                  <Visibility />
                </IconButton>
              </S.ContainerEyer>
            ) : (
              <S.ContainerEyer>
                <DateTime
                  name="orga_data_publicacao_contrato"
                  label="Data Publicação Contrato"
                  getValue={(value) => setPublish(value)}
                  serialize={(value) =>
                    value
                      .set({ hour: 0, minute: 0, seconds: 0 })
                      .format('DD/MM/YYYY HH:mm:ss')
                  }
                />

                <IconButton onClick={handleToggleVisibilityFieldDate}>
                  <VisibilityOff />
                </IconButton>
              </S.ContainerEyer>
            )}

            <Input name="orga_aliquota_ir" label="Alíquota IR" type="number" />

            <Input
              name="orga_valor_transacao"
              label="Valor Transação"
              type="number"
            />

            <Input
              name="orga_aliquota_pis"
              label="Alíquota PIS"
              type="number"
            />

            <Input
              name="orga_aliquota_cofins"
              label="Alíquota COFINS"
              type="number"
            />

            <Input
              name="orga_aliquota_csll"
              label="Alíquota CSLL"
              type="number"
            />

            <RadioGroup
              name="orga_bloqueio_inadimplencia"
              label="Bloqueio por Contrato"
              options={optionsSN}
              getValue={(value) => setNote(value === 'N')}
            />

            <Input
              multiline
              rows={4}
              name="orga_bloqueio_inadimplencia_observacao"
              label="Observação Bloqueio por Contrato"
              disabled={note}
            />
          </fieldset>
        </>
      )}
    </S.Container>
  );
}

export default Dados;

Dados.propTypes = {
  formRef: PropTypes.shape({
    current: PropTypes.any.isRequired,
  }).isRequired,
};
